function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as c from "react";
import x from "classnames";
import O from "./spinner.js";
import { BaseTouchable as d } from "./touchable.js";
import { useIsInverseVariant as k } from "./theme-variant-context.js";
import { useForm as A } from "./form-context.js";
import { pxToRem as L } from "./utils/css.js";
import { Text as D, Text3 as V, Text2 as F } from "./text.js";
import z from "./box.js";
import { getTextFromChildren as E } from "./utils/common.js";
import { useTrackingConfig as X, eventNames as B, eventCategories as R, eventActions as M } from "./utils/analytics.js";
import { useTheme as W } from "./hooks.js";
import { flattenChildren as Z } from "./skins/utils.js";
import { SMALL_ICON_SIZE as C, ICON_SIZE as G, SMALL_SPINNER_SIZE as j, SPINNER_SIZE as $, inverseVariants as H, variants as q, small as J, isLoading as K, textContent as Q, loadingFiller as U, ICON_MARGIN_PX as N, X_SMALL_PADDING_PX as Y, X_PADDING_PX as p, loadingContent as ee, link as te, inverseLink as ne, alignedLink as re, textContentLink as ie } from "./button.css-mistica.js";
import { jsxs as w, Fragment as oe, jsx as t } from "./_virtual/jsx-runtime.js";
const y = (param)=>{
    let { content: e , defaultIconSize: r , renderText: i  } = param;
    const u = Z(e), g = u.length, l = [];
    let o = [];
    const s = ()=>{
        l.push(/* @__PURE__ */ t(c.Fragment, {
            children: i(o)
        }, l.length)), o = [];
    };
    return u.forEach((a, n)=>{
        var f;
        const m = n === 0, v = n === g - 1;
        if (/*#__PURE__*/ c.isValidElement(a)) {
            o.length && s();
            const h = (f = a.props.size) != null ? f : r;
            l.push(/* @__PURE__ */ t("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    marginLeft: m ? 0 : N,
                    marginRight: v ? 0 : N
                },
                children: /*#__PURE__*/ c.cloneElement(a, {
                    size: L(h)
                })
            }, l.length));
        } else o.push(a), v && s();
    }), l;
}, S = /*#__PURE__*/ c.forwardRef((e, r)=>{
    var _;
    const { eventFormat: i  } = X(), { formStatus: u , formId: g  } = A(), l = k(), { loadingText: o  } = e, s = !!e.submit, a = u === "sending", n = e.showSpinner || a && s, [m, v] = c.useState(!!n);
    c.useEffect(()=>{
        n && !m && v(!0);
    }, [
        n,
        m,
        u
    ]);
    const P = ()=>i === "google-analytics-4" ? {
            name: B.userInteraction,
            component_type: `${e.type}_button`,
            component_copy: E(e.children)
        } : {
            category: R.userInteraction,
            action: `${e.type}_button_tapped`,
            label: E(e.children)
        }, f = e.small ? C : G, h = L(e.small ? j : $), I = (T)=>e.small ? /* @__PURE__ */ t(D, {
            size: 14,
            lineHeight: 20,
            weight: "medium",
            truncate: 1,
            color: "inherit",
            as: "div",
            children: T
        }) : /* @__PURE__ */ t(V, {
            medium: !0,
            truncate: 1,
            color: "inherit",
            as: "div",
            children: T
        }), b = {
        ref: r,
        className: x(l ? H[e.type] : q[e.type], e.className, {
            [J]: e.small,
            [K]: n
        }),
        style: _objectSpread({
            cursor: e.fake ? "pointer" : void 0
        }, e.style),
        trackingEvent: (_ = e.trackingEvent) != null ? _ : e.trackEvent ? P() : void 0,
        dataAttributes: e.dataAttributes,
        "aria-controls": e["aria-controls"],
        "aria-expanded": e["aria-expanded"],
        tabIndex: e.tabIndex,
        children: /* @__PURE__ */ w(oe, {
            children: [
                /* @__PURE__ */ t("div", {
                    "aria-hidden": n ? !0 : void 0,
                    className: Q,
                    children: y({
                        content: e.children,
                        defaultIconSize: f,
                        renderText: I
                    })
                }),
                /* @__PURE__ */ t("div", {
                    className: U,
                    "aria-hidden": !0,
                    style: {
                        paddingLeft: h,
                        paddingRight: N + 2 * (e.small ? Y : p)
                    },
                    children: y({
                        content: o,
                        defaultIconSize: f,
                        renderText: I
                    })
                }),
                /* @__PURE__ */ w("div", {
                    "aria-hidden": n ? void 0 : !0,
                    className: ee,
                    onTransitionEnd: ()=>{
                        n !== m && v(n);
                    },
                    children: [
                        m ? /* @__PURE__ */ t(O, {
                            rolePresentation: !!o,
                            color: "currentcolor",
                            delay: "0s",
                            size: h
                        }) : /* @__PURE__ */ t("div", {
                            style: {
                                display: "inline-block",
                                width: h,
                                height: h
                            }
                        }),
                        o ? /* @__PURE__ */ t(z, {
                            paddingLeft: 8,
                            children: y({
                                content: o,
                                defaultIconSize: f,
                                renderText: I
                            })
                        }) : null
                    ]
                })
            ]
        }),
        disabled: e.disabled || n || a,
        role: "button"
    };
    if (process.env.NODE_ENV !== "production" && (e.to === "" || e.href === "")) throw Error("to or href props are empty strings");
    if (e.fake) return /* @__PURE__ */ t(d, _objectSpreadProps(_objectSpread({
        maybe: !0
    }, b), {
        role: "presentation",
        "aria-hidden": "true"
    }));
    if (e.submit) return /* @__PURE__ */ t(d, _objectSpread({
        type: "submit",
        formId: g,
        onPress: ()=>{}
    }, b));
    if (e.onPress) return /* @__PURE__ */ t(d, _objectSpreadProps(_objectSpread({}, b), {
        onPress: e.onPress
    }));
    if (e.to || e.to === "") return /* @__PURE__ */ t(d, _objectSpreadProps(_objectSpread({}, b), {
        to: e.to,
        fullPageOnWebView: e.fullPageOnWebView
    }));
    if (e.href || e.href === "") return /* @__PURE__ */ t(d, _objectSpreadProps(_objectSpread({}, b), {
        href: e.href,
        newTab: e.newTab,
        loadOnTop: e.loadOnTop
    }));
    if (process.env.NODE_ENV !== "production") throw Error("Bad button props");
    return null;
}), Ie = /*#__PURE__*/ c.forwardRef((e, r)=>{
    var a;
    const { formStatus: i  } = A(), u = k(), { analytics: g  } = W(), l = ()=>g.eventFormat === "google-analytics-4" ? {
            name: B.userInteraction,
            component_type: "link",
            component_copy: E(e.children)
        } : {
            category: R.userInteraction,
            action: M.linkTapped,
            label: E(e.children)
        }, o = (n)=>/* @__PURE__ */ t(F, {
            medium: !0,
            truncate: 1,
            color: "inherit",
            children: n
        }), s = {
        className: x(te, {
            [ne]: u,
            [re]: e.aligned
        }),
        trackingEvent: (a = e.trackingEvent) != null ? a : e.trackEvent ? l() : void 0,
        dataAttributes: _objectSpread({
            "component-name": "ButtonLink"
        }, e.dataAttributes),
        children: /* @__PURE__ */ t("div", {
            className: ie,
            children: y({
                content: e.children,
                defaultIconSize: C,
                renderText: o
            })
        }),
        disabled: e.disabled || i === "sending"
    };
    if (process.env.NODE_ENV !== "production" && (e.to === "" || e.href === "")) throw Error("to or href props are empty strings");
    if (e.onPress) return /* @__PURE__ */ t(d, _objectSpreadProps(_objectSpread({
        ref: r
    }, s), {
        onPress: e.onPress
    }));
    if (e.to || e.to === "") return /* @__PURE__ */ t(d, _objectSpreadProps(_objectSpread({
        ref: r
    }, s), {
        to: e.to,
        fullPageOnWebView: e.fullPageOnWebView
    }));
    if (e.href || e.href === "") return /* @__PURE__ */ t(d, _objectSpreadProps(_objectSpread({
        ref: r
    }, s), {
        href: e.href,
        newTab: e.newTab
    }));
    if (process.env.NODE_ENV !== "production") throw Error("Bad button props");
    return null;
}), Ne = /*#__PURE__*/ c.forwardRef((_param, i)=>/* @__PURE__ */ {
    var { dataAttributes: e  } = _param, r = _objectWithoutProperties(_param, [
        "dataAttributes"
    ]);
    return t(S, _objectSpreadProps(_objectSpread({
        dataAttributes: _objectSpread({
            "component-name": "ButtonPrimary"
        }, e)
    }, r), {
        ref: i,
        type: "primary"
    }));
}), Se = /*#__PURE__*/ c.forwardRef((_param, i)=>/* @__PURE__ */ {
    var { dataAttributes: e  } = _param, r = _objectWithoutProperties(_param, [
        "dataAttributes"
    ]);
    return t(S, _objectSpreadProps(_objectSpread({
        dataAttributes: _objectSpread({
            "component-name": "ButtonSecondary"
        }, e)
    }, r), {
        ref: i,
        type: "secondary"
    }));
}), Pe = /*#__PURE__*/ c.forwardRef((_param, i)=>/* @__PURE__ */ {
    var { dataAttributes: e  } = _param, r = _objectWithoutProperties(_param, [
        "dataAttributes"
    ]);
    return t(S, _objectSpreadProps(_objectSpread({
        dataAttributes: _objectSpread({
            "component-name": "ButtonDanger"
        }, e)
    }, r), {
        ref: i,
        type: "danger"
    }));
});
export { Pe as ButtonDanger, Ie as ButtonLink, Ne as ButtonPrimary, Se as ButtonSecondary };
